define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Field",
	"csi/table/Copy",
	"csi/xml"
], function(declare, lang, Field, Copy, xml) {

	return declare(Copy, {

		getFormData: function() {
			// summary: when copying Theme make sure to blank out seasons
			var fd = this.inherited(arguments);
			fd.setFieldInitialValue("ThemeSeasons", "");
			return fd;
		},

		getActionView: function(/*ViewRef?*/vr) {
			// summary: Theme copy form - display Theme Master Subtype read-only
			var av = this.inherited(arguments);
			if (av) {
				av.m_defView.addField(lang.mixin(new Field(), {
					m_id: "Subtype",
					m_path: "Child:__Parent__",
					m_right: xml.RIGHT_NONE
				}), "ThemeSeason");
			}

			return av;
		},

		onValidate() {
			var fd = this.getFormData();
			fd.getField("Subtype").m_bUsed = true;
			this.inherited(arguments);
		}
	});
});